const NonConformityTypes = {
  // NON CONFORMITY
  GET_FULL_ANOMALIES: "GET_FULL_ANOMALIES",
  GET_FULL_ANOMALIES_SUCCESS: "GET_FULL_ANOMALIES_SUCCESS",

  GET_FULL_INCIDENTS: "GET_FULL_INCIDENTS",
  GET_FULL_INCIDENTS_SUCCESS: "GET_FULL_INCIDENTS_SUCCESS",

  GET_FULL_AUDIT_RECOMMENDATIONS: "GET_FULL_AUDIT_RECOMMENDATIONS",
  GET_FULL_AUDIT_RECOMMENDATIONS_SUCCESS: "GET_FULL_AUDIT_RECOMMENDATIONS_SUCCESS",
  PATCH_STATUT_NON_CONFORMITY: "PATCH_STATUT_NON_CONFORMITY",
  CREATE_NON_CONFORMITY: "CREATE_NON_CONFORMITY",
  DELETE_NON_CONFORMITY: "DELETE_NON_CONFORMITY",
  PATCH_NON_CONFORMITY: "PATCH_NON_CONFORMITY",
  // TASKS
  VALIDATED_TASK: "VALIDATED_TASK",
}

export default NonConformityTypes
